<template id="boton-proceso">
  <div>
    <div class="btn-proceso">
      <v-layout
        class="botones-colores"
        align-center
        justify-center
        fill-height
        wrap
      >
        <v-flex
          xs2
          v-for="(btn, index) in lstBtn"
          :key="index"
          @click="activateBtn(btn)"
        >
          <v-flex botones>
            <mini-statistic
              :icon="btn.icon"
              :title="btn.title"
              :sub-title="btn.subtitle"
              :color="btn.color"
              :class="btn.class"
              :value="true"
            ></mini-statistic>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <div class="tab-impresion">
      <impresion-sub-tab
        v-if="subPro == 'IMPRESION'"
        :show="true"
        :tipeView="'modifica'"
      ></impresion-sub-tab>
      <visita-sub-tab
        v-if="tab == 'Visitas'"
        :show="true"
        :tipeView="'modifica'"
      ></visita-sub-tab>
      <mecanizado-sub-tab
        v-if="subPro == 'MECANIZADO'"
        :show="true"
        :tipeView="'modifica'"
      ></mecanizado-sub-tab>
      <distribucion-sub-tab
        v-if="tab == 'Acuerdo' && subPro == 'DISTRIBUCION'"
        :show="true"
        :tipeView="'modifica'"
      ></distribucion-sub-tab>
      <administrativo-sub-tab
        v-if="tab == 'Administrativo'"
        :show="true"
        :tipeView="'modifica'"
      ></administrativo-sub-tab>
      <reportes-sub-tab
        v-if="subPro == 'PROD'"
        :show="true"
        :tipeView="'modifica'"
      ></reportes-sub-tab>
    </div>
  </div>
</template>

<script>
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import VisitaSubTab from "@/modules/visitas/views/VisitaSubTab.vue";
import ImpresionSubTab from "@/modules/impresion/views/proceso/ImpresionSubTab.vue";
import MecanizadoSubTab from "@/modules/mecanizado/views/proceso/MecanizadoSubTab.vue";
import DistribucionSubTab from "@/modules/distribucion/views/proceso/DistribucionSubTab.vue";
// import AdministrativoSubTab from "@/modules/administrativo/views/AdministrativoSubTab.vue";
import AdministrativoSubTab from "@/modules/adminDocs/views/AdministracionSubTab.vue";
import ReportesSubTab from "@/modules/prodReport/views/ReportesSubTab.vue";

export default {
  name: "boton-proceso",
  props: {
    lstBtn: "",
  },
  data() {
    return {
      impresionBtn: false,
      tab: "Acuerdos",
      subPro: "Sin Proceso",
    };
  },
  components: {
    MiniStatistic,
    VisitaSubTab,
    ImpresionSubTab,
    MecanizadoSubTab,
    DistribucionSubTab,
    AdministrativoSubTab,
    ReportesSubTab,
  },
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
  },

  watch: {
    lstBtn(val) {
      if (this.subPro != "") {
        let btnSeleccionado = this.lstBtn.filter((d) =>
          this.subPro
            .split(" ")
            .every((v) => d.title.toLowerCase().includes(v.toLowerCase()))
        );
        if (btnSeleccionado.length > 0) {
          btnSeleccionado[0].class =
            "activo rombo " + this.subPro.toLowerCase();
        } else {
          this.lstBtn.forEach((b) => {
            if (b.title.toLowerCase() == this.subPro.toLowerCase()) {
              b.class = "activo rombo " + this.subPro.toLowerCase();
            }
          });
        }
      }
    },
  },

  mounted() {},

  methods: {
    activateBtn(btn) {
      this.tab = btn.tab;
      this.subPro = btn.subPro;
      this.$store.commit("sub_tab_state", this.tab);
      this.$store.commit("sub_pro_tab_state", this.subPro);

      this.lstBtn.forEach((b) => {
        if (b.title != btn.title) {
          //desactiva b: quita "activo" y agrega  elevation-10
          b.class = b.class.replaceAll("activo", "");
          b.class = b.class.replaceAll("elevation-10", "");
          b.class += " elevation-10";
          //console.log("desactiva:" + b.title + ":" + b.class + "::");
        } else {
          //activa b:agrega activo, quita  elevation-10
          b.class = b.class.replaceAll("elevation-10", "");
          b.class += " activo";
          // console.log("activa:" + b.title + ":" + b.class + "::");
        }
      });
    },
  },
};
</script>
